import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use( ElementUI, { size: 'small' } );
Vue.config.productionTip = false
// 全局修改默认配置，按下ESC不能关闭弹窗
ElementUI.Dialog.props.closeOnPressEscape.default = false;
// 全局修改默认配置，点击空白处不能关闭弹窗
ElementUI.Dialog.props.closeOnClickModal.default = false;

import $http from './http/request';
Vue.prototype.$http = $http;


import 'bootstrap/dist/css/bootstrap.min.css'


import VueCountUp from 'vue-countupjs'//数字快速增长动画插件
Vue.use(VueCountUp)
Vue.component('VueCountUp', VueCountUp) //全局注册组件

import vant from 'vant';
import 'vant/lib/index.css';
Vue.use(vant);

// Vue.prototype.$myGlobalMethods = function (screenWidth) {
// 	let isSmallScreen = false;
//     //获取屏幕宽度
    
//     if(screenWidth < 1000){
// 		Dialog.alert({
// 			title: '提示',
// 			message: '请在大屏幕PC端上操作',
// 		}).then(() => {
// 			// on close
// 		});
// 		isSmallScreen = true;
//     }
// 	return isSmallScreen;
// };
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
